<div class="login-inside-container" id="div_login-inside-container_e993aba9">
  <h1
    title="Forgot your password"
    aria-label="Forgot your password"
    id="h1_d7a418f2"
  >
    Forgot your password?
  </h1>
  <form [formGroup]="frmForgotPassword" id="form_e798aed5">
    <label id="label_9a144543"
      >To reset your password, enter the verification code in the email we just
      sent.</label
    >
    <span class="p-float-label" id="span_p-float-label_d01b6ff0">
      <input
        id="verificationCode"
        type="text"
        pInputText=""
        name="verificationCode"
        formControlName="verificationCode"
        aria-label="Verification Code Input"
      />
      <label for="verificationCode" id="label_3a6ce035"
        >Verification Code</label
      >
    </span>
    <small
      class="p-error block"
      *ngIf="verificationCodeError === verificationErrorStatus.CODE_EXPIRED"
      aria-label="Verification code has expired. Click the link below for a new code."
      id="small_p-error_14bae063"
      >Verification code has expired. Click link below for new code.</small
    >
    <small
      class="p-error block"
      *ngIf="verificationCodeError === verificationErrorStatus.INVALID_CODE"
      aria-label="Verification code is invalid. Please try again or contact your account manager."
      id="small_p-error_7c5c286a"
      >Verification code is invalid. Please try again or contact your account
      manager.</small
    >
    <span class="p-float-label" id="span_p-float-label_9cbafd7d">
      <input
        id="newPassword"
        type="password"
        [pTooltip]="toolTip"
        tooltipEvent="focus"
        [escape]="false"
        tooltipPosition="right"
        pInputText=""
        name="newPassword"
        formControlName="newPassword"
        aria-label="New Password Input"
      />
      <label for="newPassword" id="label_89757061">New Password</label>
    </span>
    <small
      class="p-error block"
      *ngIf="frmForgotPassword.controls['newPassword'].hasError('pattern')"
      aria-label="Password does not meet requirements."
      id="small_p-error_8a618602"
      >Password does not meet requirements.</small
    >
    <span class="p-float-label" id="span_p-float-label_a688ed57">
      <input
        id="confirmPassword"
        type="password"
        [pTooltip]="toolTip"
        tooltipEvent="focus"
        [escape]="false"
        tooltipPosition="right"
        pInputText=""
        name="confirmPassword"
        formControlName="confirmPassword"
        aria-label="Confirm New Password Input"
      />
      <label for="confirmPassword" id="label_4f96de93"
        >Confirm New Password</label
      >
    </span>
    <small
      class="p-error block"
      *ngIf="
        frmForgotPassword.value.newPassword !==
        frmForgotPassword.value.confirmPassword
      "
      aria-label="Passwords do not match."
      id="small_p-error_d36bee53"
      >Passwords do not match.</small
    >
    <div class="captcha-row" id="div_captcha-row_2c6f58c3">
      <p-captcha
        siteKey="6LcPRjciAAAAANIVIBXMAQpTlSJ8ZMF_4Ih4fIqw"
        (onExpire)="resetCaptcha()"
        (onResponse)="showResponse($event)"
        aria-label="Captcha"
        id="p-captcha_2b4d9f7f"
      ></p-captcha>
    </div>
    <div class="btn-panel" id="div_btn-panel_da29cd39">
      <button
        class="next-button"
        (click)="confirm()"
        [disabled]="!frmForgotPassword.valid || captcha_token === ''"
        aria-label="Confirm Button"
        id="button_next-button_e2eff563"
      >
        CONFIRM
      </button>
    </div>
  </form>
</div>
<div class="bottom-pnl" id="div_bottom-pnl_70183ac3">
  <p id="p_05e10f3b">
    Link expired?
    <a
      aria-label="Email new code"
      title="Email new code"
      (click)="emailNewCode()"
      id="a_fc0b57a8"
      >Email new code.</a
    >
  </p>
  <p id="p_0730904b">
    Didn't get an email? Please contact your account manager.
  </p>
</div>

<p-toast
  position="top-center"
  life="500000"
  key="toast"
  id="p-toast_ed1d65cc"
></p-toast>
<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_e842d9f8"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    aria-label="Loading Spinner"
    id="p-progressSpinner_2959b4be"
  ></p-progressSpinner>
</div>
